import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Card, Button, Row, Col, Image } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { ResourceManager } from '../../../core/resource-manager';
import photo from '../../../assets/photo_home_evento.svg'
import moment from 'moment';




export default function CardPubblicazione({ data }) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [image, setImage] = useState(null);

    useEffect(() => {

        var image = {
            hash: data.hash,
            extension: data.extension
        }
        console.log('data-card', data)
        setImage(image.hash ? ResourceManager.getFileUrl(image, data.entity) : ResourceManager.getFileUrl(data.image, 'publication'))
    }, [data]);

    function clickAction() {
        navigate('/pubblicazioni/' + data.id)
    }


    if (data) {
        return (
            <Container className='my-3 text-center'>
                {/* <Card style={{ borderRadius: '16px', cursor: 'pointer' }} className='h-100' onClick={() => clickAction()}>
                    <Card.Img variant="top" src={image} style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px', width: '100%', objectFit: 'cover', maxHeight: '435px' }} />
                    <Card.Body>
                        <Card.Text style={{ color: 'var(--primary-color)' }}>
                            {moment(data.publicationDate).format('MMMM YYYY')}
                        </Card.Text>
                        <Card.Title style={{ color: 'var(--primary-color)' }}>
                            <h6 style={{
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                WebkitLineClamp: 2,
                            }}>{data.title}</h6>
                        </Card.Title>
                        {data.paid === 1 ? <Card.Text className='mb-0'><h5>{parseFloat(data.price).toFixed(2)} €</h5></Card.Text> : null}
                        <Button className='rounded-pill px-3 mt-4' onClick={() => clickAction()}>Scopri di più</Button>
                    </Card.Body>
                </Card> */}
                <Row style={{ borderRadius: '16px', border: '1px solid rgba(0, 0, 0, 0.125)' }} >
                    <Col className='px-0 py-2'>
                        <div className='my-2'>
                            <span style={{color: 'var(--primary-color)'}}>{data.category}</span>
                            <h6 style={{
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                WebkitLineClamp: 2,
                                color: 'var(--primary-color)',
                                fontWeight: '500'
                            }} className='m-2'>{data.title}</h6>
                            <span  style={{color: 'var(--primary-color)'}}>{moment(data.publicationDate).format('MMMM YYYY')}</span>
                        </div>
                        <Image src={image} style={{ width: '100%', objectFit: 'cover' }} ></Image>
                        <div className='my-2'>
                            {data.paid === 1 ? <Card.Text className='mb-0'><h5>{parseFloat(data.price).toFixed(2)} €</h5></Card.Text> : null}
                            <Button className='rounded-pill px-3 mt-4' onClick={() => clickAction()}>Scopri di più</Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};